import { computed as m, resolveComponent as O, createBlock as u, openBlock as r, unref as t, withCtx as s, createCommentVNode as c, createElementBlock as p, createVNode as a, createTextVNode as f, Fragment as C, renderList as $, toDisplayString as d, createElementVNode as h } from "vue";
import w from "lodash/has";
import { BNavItemDropdown as S, BDropdownItem as g, BDropdownDivider as V } from "bootstrap-vue-next";
import { PermissionConstants as E } from "@switchsystems/coactive-node-lib-permissions";
import { g as v } from "../lib/getAppUrl.zOygEGj2.js";
import { u as P } from "../stores/auth.al0TMRKc.js";
import '../../assets/components/NavUserDropdown.css';const j = ["aria-label"], I = ["aria-label"], U = { class: "d-none d-md-inline" }, M = { class: "d-inline d-md-none" }, T = ["aria-label"], G = {
  __name: "NavUserDropdown",
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    appBadgeCounts: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["logout-clicked"],
  setup(x, { emit: N }) {
    const e = x, y = P(), A = N, b = m(() => import.meta.env.VITE_APP_NAME), _ = m(
      () => Object.values(e.appBadgeCounts).reduce((l, n) => l + n, 0)
    ), k = m(() => w(e.user, "profile") ? `${e.user.profile.firstName} ${e.user.profile.lastName}` : e.user.email), D = m(() => w(e.user, "profile") ? `${e.user.profile.firstName}` : e.user.email.substring(0, e.user.email.indexOf("@")));
    function B(l) {
      l.preventDefault(), A("logout-clicked");
    }
    return (l, n) => {
      const i = O("font-awesome-icon");
      return r(), u(t(S), { right: "" }, {
        "button-content": s(() => [
          _.value > 0 ? (r(), p("span", {
            key: 0,
            class: "unread-count me-1 rounded-pill badge text-bg-danger",
            role: "status",
            "aria-label": `${_.value} unread messages`
          }, d(_.value), 9, j)) : (r(), u(i, {
            key: 1,
            "fixed-width": "",
            icon: "user"
          })),
          h("span", {
            id: "user-nav-name",
            "data-dd-privacy": "mask",
            "aria-label": k.value
          }, [
            h("span", U, d(k.value), 1),
            h("span", M, d(D.value), 1)
          ], 8, I)
        ]),
        default: s(() => [
          b.value !== "home" ? (r(), u(t(g), {
            key: 0,
            href: t(v)("home")
          }, {
            default: s(() => [
              a(i, {
                "fixed-width": "",
                icon: "home"
              }),
              n[0] || (n[0] = f(" Home Portal "))
            ]),
            _: 1
          }, 8, ["href"])) : c("", !0),
          (r(!0), p(C, null, $(t(E).apps, (o) => (r(), p(C, {
            key: o.id
          }, [
            t(y).canAccessApp(o.id) && b.value !== o.id ? (r(), u(t(g), {
              key: 0,
              href: t(v)(o.id)
            }, {
              default: s(() => [
                a(i, {
                  "fixed-width": "",
                  icon: o.icon
                }, null, 8, ["icon"]),
                f(" " + d(o.name) + " ", 1),
                e.appBadgeCounts[o.id] && e.appBadgeCounts[o.id] > 0 ? (r(), p("span", {
                  key: 0,
                  class: "unread-count rounded-pill badge text-bg-danger",
                  role: "status",
                  "aria-label": `${e.appBadgeCounts[o.id]} unread messages`
                }, d(e.appBadgeCounts[o.id]), 9, T)) : c("", !0)
              ]),
              _: 2
            }, 1032, ["href"])) : c("", !0)
          ], 64))), 128)),
          a(t(V)),
          t(y).isAgencyUser ? c("", !0) : (r(), u(t(g), {
            key: 1,
            href: `${t(v)("home")}/my-account`
          }, {
            default: s(() => [
              a(i, {
                "fixed-width": "",
                icon: "user"
              }),
              n[1] || (n[1] = f(" My Account "))
            ]),
            _: 1
          }, 8, ["href"])),
          a(t(g), {
            onClick: B,
            onKeypress: B
          }, {
            default: s(() => [
              a(i, {
                "fixed-width": "",
                icon: "sign-out-alt"
              }),
              n[2] || (n[2] = f(" Sign Out "))
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
};
export {
  G as _
};
